// Phase 3.2b — Cycle Count product panel (right side of the detail screen).
//
// UI-only migration: antd Row/Col/Form/Radio/Input/Empty/Tooltip + MUI
// Drawer/InputLabel/Skeleton → shadcn grid/RadioGroup/Input/EmptyState/Tooltip +
// Sheet + Skeleton; antd message.success → Sonner toast; SpinLoader →
// LoadingOverlay. Every hook, effect, payload and dispatch below is the legacy
// one, untouched — only the rendered markup changed. The antd Form is dropped in
// favour of inputs controlled by the existing `itemCountData` state (the same
// state the form fields mirrored).
import { toast } from "sonner"
import AppImages from "../../Globals/AppImages"
import { useEffect, useState } from "react"
import AppConstant from "../../Globals/AppConstants"
import { useDispatch, useSelector } from "react-redux"
import { getProductListByCategory, getupdateCycleCountProductStatus } from "../../Store/actions/apparelAction"
import { deepCopyFunction, isArrayNotEmpty } from "../../Utils/helpers"
import { useLocation } from "react-router-dom"
import { Sheet, SheetContent } from "ui/sheet"
import { Button } from "ui/button"
import { Input } from "ui/input"
import { Label } from "ui/label"
import { RadioGroup, RadioGroupItem } from "ui/radio-group"
import { Skeleton } from "ui/skeleton"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "ui/tooltip"
import { EmptyState } from "../../shared/empty-state"
import { LoadingOverlay } from "../../shared/loading-overlay"
import { cn } from "lib/utils"

const StatusCycleCount = (props: any) => {
    const dispatch = useDispatch()
    const { single,
        productCategroryMappingId,
        statusRefIdOnClick,
        countValue,
        callBack,
        getProduct,
        pendingButton } = props;
    const [color, setcolor] = useState(null)
    const locationProps = useLocation().state;
    const [idx, setIdx] = useState(0)
    const [spinner, setspinner] = useState(false)
    const [itemCountDrawerOpen, setItemCountDrawerOpen] = useState(false);
    const [drawer, setDrawer] = useState<any>();
    const [manualCount, setManualCount] = useState<any>(0);
    const [missingCount, setMissingCount] = useState<any>(0);

    const [open, setOpen] = useState(false);
    const [validation, setValidation] = useState(false);
    const [markAsButton, setMarkAsButton] = useState(true)
    const [createOrUpdateProductStatusLoad, setCreateOrUpdateProductStatusLoad] = useState(false)
    const [isButtonDisabled, setButtonDisabled] = useState(true);
    const [formvalidator, setformvalidator] = useState<any>();
    const [getProductListLoad, setGetProductListLoad] = useState(false);
    const [spinOpen, setSpinOpen] = useState(false)
    const [InfiniteScroll, setInfiniteScroll] = useState(18)
    const ApparelReducerState = useSelector((state: any) => state.ApparelReducerState);
    const { getMultipleCategoryListData, getProductListCategoryListOnLoad, getUpdateCycleCountOnLoad, getProductListCategoryData, getMultipleCategoryListOnLoad } = ApparelReducerState;
    // const getProduct = getProductListCategoryData?.getProductListByCategorySubCategory;
    const getCategory = getMultipleCategoryListData?.getCategorySubcategoryList?.categorySubcategoryData;

    useEffect(() => {
        setManualCount(0)
        setMissingCount(0)
    }, [pendingButton, single])

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    // Function to update the window height state
    const updateWindowHeight = () => {
        setWindowHeight(window.innerHeight);
    };
    // Add a resize event listener when the component mounts
    useEffect(() => {
        window.addEventListener('resize', updateWindowHeight);
        return () => {
            window.removeEventListener('resize', updateWindowHeight);
        };

    }, []);


    const itemCountTemp = {
        availableCount: null,
        missingCount: null,
        statusRefId: null
    }
    const [itemCountData, setitemCountData] = useState<any>(deepCopyFunction(itemCountTemp))
    const prePopulateCountData = (drawerData: any) => {
        try {
            setitemCountData({
                availableCount: drawerData?.availableCount,
                missingCount: drawerData?.missingCount
            })
        } catch (error) {
            console.log("Error in prePopulateCountData" + error);
        }
    }

    const getProductListByCategoryApi = () => {
        let payload = {
            categoryAndSubCategoryMappingId: productCategroryMappingId,
            cycleCountJobId: locationProps?.data?.cycleCountJobId,
            isMultipleRecords: single,
            isCycleCompleted: locationProps?.data?.statusRefId == 1 ? 2 : locationProps?.data?.statusRefId,
            type: pendingButton == 1 ? AppConstant?.PENDING : AppConstant?.COMPLETED
        }
        dispatch(getProductListByCategory(payload))
        setGetProductListLoad(true)
    }

    useEffect(() => {
        if (productCategroryMappingId && !getMultipleCategoryListOnLoad) {
            setInfiniteScroll(18)
            getProductListByCategoryApi()
            setInfiniteScroll(18)
        }
    }, [productCategroryMappingId, getMultipleCategoryListOnLoad]);

    const onhandle = (e: any, index: any, data: any) => {
        setIdx(index)
        setcolor(e)
        createOrUpdateProductStatusApi(e?.target?.value, data)
    }

    const createOrUpdateProductStatusApi = (value: any, product: any) => {

        let payload = {
            cycleCountJobDetailId: product?.cycleCountJobDetailId ? product?.cycleCountJobDetailId : drawer?.cycleCountJobDetailId ? drawer?.cycleCountJobDetailId : "",
            cycleCountJobId: locationProps?.data?.cycleCountJobId,
            categoryAndSubCategoryMappingId: productCategroryMappingId,
            productItemId: product?.productItemId ? product?.productItemId : drawer?.productItemId,
            statusRefId: null,
            availableCount: itemCountData.availableCount ? itemCountData.availableCount : value == 1 ? 1 : 0,
            missingCount: itemCountData.missingCount ? itemCountData.missingCount : value == 2 ? 1 : 0,
        }
        dispatch(getupdateCycleCountProductStatus(payload))
        setitemCountData(true)
        setCreateOrUpdateProductStatusLoad(true)
        setspinner(true)
    }


    useEffect(() => {
        if (getProductListLoad && !getProductListCategoryListOnLoad) {
            if (typeof getProduct != "string" && isArrayNotEmpty(getProduct)) {
                setManualCount(getProduct.reduce((total: any, item: any) => total + (item.availableCount ? parseInt(item.availableCount) : 0), 0))
                setMissingCount(getProduct.reduce((total: any, item: any) => total + (item.missingCount ? parseInt(item.missingCount) : 0), 0))
            }
            setGetProductListLoad(false);
        }
    }, [getProductListLoad, getProductListCategoryListOnLoad])


    const itemDrawerFunc = (item: any) => {
        setDrawer(item);
    }

    useEffect(() => {
        if (drawer) {
            setItemCountDrawerOpen(true)
            prePopulateCountData(drawer)
        }
    }, [drawer]);

    const closeItemCount = () => {
        setButtonDisabled(true)
        setValidation(false)
        setOpen(false)
        setItemCountDrawerOpen(false)
        setDrawer("");
        setitemCountData(deepCopyFunction(itemCountTemp))
    }
    useEffect(() => {
        if (createOrUpdateProductStatusLoad == true && getUpdateCycleCountOnLoad == false) {
            productCategroryMappingId && getProductListByCategoryApi()
            setTimeout(() => {
                setCreateOrUpdateProductStatusLoad(false);
                toast.success("Updated Successfully")
            }, 700);
            setspinner(false)
        }
    }, [createOrUpdateProductStatusLoad, getUpdateCycleCountOnLoad])

    useEffect(() => {
        if (itemCountData) {
            if ((itemCountData.availableCount && itemCountData.missedcount) || itemCountData.availableCount) {
                itemCountData.statusRefId = 1
            }
            else if (itemCountData.missingCount) {
                itemCountData.statusRefId = 2
            }
            let data1 = parseInt(itemCountData.availableCount ? itemCountData.availableCount : 0);
            let data2 = parseInt(itemCountData.missingCount ? itemCountData.missingCount : 0);
            const value = data1 + data2;
            setformvalidator(value)
            if ((value == drawer?.itemCount || value < drawer?.itemCount) && value != 0) {
                setButtonDisabled(false)
            }
            else {
                setButtonDisabled(true)
            }
        }
    }, [itemCountData])

    useEffect(() => {
        if (getUpdateCycleCountOnLoad == true) {
            setDrawer("");
            setItemCountDrawerOpen(false)
            setitemCountData(false)
            setspinner(false)
        }
    }, [getUpdateCycleCountOnLoad])

    const updateCycleCount = (value: any) => {
        callBack(value)
    }

    const itemCountDrawer = () => {
        return (
            <Sheet open={itemCountDrawerOpen} onOpenChange={(o) => { if (!o) closeItemCount(); }}>
                <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-md">
                    <div className="flex items-start justify-between border-b px-5 py-4">
                        <div>
                            <div className="text-base font-semibold text-foreground">{drawer?.productName}</div>
                            <div className="text-sm text-muted-foreground">{`(${drawer?.productId})`}</div>
                        </div>
                        <div className="mr-8 text-sm font-medium">Item Count - {drawer?.itemCount}</div>
                    </div>
                    <form
                        className="flex flex-1 flex-col gap-4 p-5"
                        onSubmit={(e) => { e.preventDefault(); createOrUpdateProductStatusApi("", ""); }}
                    >
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-1.5">
                                <Label>Available Count</Label>
                                <Input
                                    type="number"
                                    value={itemCountData?.availableCount ?? ""}
                                    onChange={(e: any) => { setitemCountData({ ...itemCountData, availableCount: e?.target?.value }) }}
                                />
                                {formvalidator > drawer?.itemCount && <div className="text-sm text-destructive">value greater than item count</div>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Missed Count</Label>
                                <Input
                                    type="number"
                                    value={itemCountData?.missingCount ?? ""}
                                    onChange={(e: any) => { setitemCountData({ ...itemCountData, missingCount: e?.target?.value }) }}
                                />
                            </div>
                        </div>

                        <div className="mt-auto flex justify-end gap-2">
                            <Button type="button" variant="outline" onClick={() => closeItemCount()}>{AppConstant?.cancel}</Button>
                            <Button type="submit" disabled={isButtonDisabled}>{AppConstant?.save}</Button>
                        </div>
                    </form>
                </SheetContent>
            </Sheet>
        )
    }
    useEffect(() => {
        if (manualCount + missingCount == countValue) {
            setMarkAsButton(false)
        }
        else {
            setMarkAsButton(true)
        }
    }, [manualCount, missingCount, countValue])

    const handleScroll = (e: any) => {
        let bottom;
        if (Math.ceil(e?.target?.scrollHeight) - Math.ceil(e?.target?.scrollTop) === Math.ceil(e?.target?.clientHeight)) {
            bottom = Math.ceil(e?.target?.scrollHeight) - Math.ceil(e?.target?.scrollTop) === Math.ceil(e?.target?.clientHeight)
        }
        else {
            bottom = Math.floor(e?.target?.scrollHeight) - Math.floor(e?.target?.scrollTop) === Math.floor(e?.target?.clientHeight)
        }
        setSpinOpen(false)
        if (bottom) {
            let scroll = isArrayNotEmpty(getProduct) && (getProduct?.length > InfiniteScroll) ? 18 : 0
            setInfiniteScroll(scroll + InfiniteScroll)
            if (isArrayNotEmpty(getProduct) && (getProduct?.length > InfiniteScroll)) {
                setSpinOpen(true)
            }
        }
    }

    let skeletonList: any = [1, 2, 3, 4, 5, 6];
    const available = () => {
        let height = locationProps?.data?.statusRefId == 3 ? windowHeight - 160 : windowHeight - 230;
        return (
            <div className="overflow-y-auto px-4 py-3" style={{ height: height }}
                onScroll={(e) => (handleScroll(e))}
            >
                <div className="mb-3 flex flex-wrap items-center gap-x-6 gap-y-2">
                    <div className="text-sm font-medium">{`System Count : ${countValue ? countValue : AppConstant?.zero}`}</div>
                    <div className="text-sm font-medium">{`Manual Count : ${manualCount !== null ? manualCount : AppConstant?.zero}`}</div>
                    <div className="text-sm font-medium">{`Missing Count : ${missingCount != null ? missingCount : AppConstant?.zero}`}</div>

                    {locationProps?.data?.statusRefId != 3 ?
                        <div className="ml-auto">
                            {statusRefIdOnClick === null ?
                                <Button
                                    disabled={locationProps?.data?.statusRefId === 4 || markAsButton}
                                    onClick={() => updateCycleCount(2)}
                                > Move To Completed </Button>
                                :
                                <Button
                                    variant="outline"
                                    onClick={() => updateCycleCount(1)}
                                    disabled={locationProps?.data?.statusRefId === 4 || manualCount + missingCount === countValue || manualCount + missingCount === 0}
                                > Move To Pending </Button>
                            }
                        </div>
                        :
                        ""
                    }
                </div>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                    {(getProductListCategoryListOnLoad || getMultipleCategoryListOnLoad) ?
                        (skeletonList.map((item: any, i: any) => (
                            <div key={`sk-${i}`} className="space-y-2">
                                <Skeleton className="h-[120px] w-full rounded-lg" />
                                <Skeleton className="h-6 w-2/3" />
                            </div>
                        )))
                        :
                        ((isArrayNotEmpty(getCategory) && typeof getProduct != "string") && isArrayNotEmpty(getProduct) ?
                            ((getProduct.slice(0, InfiniteScroll) || []).map((data: any, index: any) => {
                                return (
                                    <div key={`${index}available`}
                                        className={cn(
                                            "rounded-lg border p-3",
                                            (data?.isAvailable >= 0 && data?.isAvailable !== null) && "ring-1 ring-primary"
                                        )}
                                    >
                                        <div className="space-y-1">
                                            <div className="flex items-start justify-between gap-2">
                                                <TooltipProvider>
                                                    <Tooltip>
                                                        <TooltipTrigger asChild>
                                                            <div className="truncate font-medium">{data?.productName}</div>
                                                        </TooltipTrigger>
                                                        <TooltipContent>{data?.productName}</TooltipContent>
                                                    </Tooltip>
                                                </TooltipProvider>
                                                {(statusRefIdOnClick !== null && single == 0) || (locationProps?.data?.statusRefId == 3 && single == 0) ?
                                                    <div className="shrink-0 text-sm text-muted-foreground">Item Count-{data?.itemCount}</div> : ""}
                                            </div>
                                            <div className="text-sm text-muted-foreground">{data?.productId}</div>
                                            <div className="flex items-center gap-1 text-sm font-medium">
                                                <img className="h-3.5 w-3.5" src={AppImages?.rupeesimg} alt="" />
                                                {data?.rate}
                                            </div>
                                        </div>
                                        {single == 1
                                            ?
                                            locationProps?.data?.statusRefId != 3 && statusRefIdOnClick == null ?
                                                <div className="mt-3 flex items-center gap-3 border-t pt-3">
                                                    <div className="text-sm font-medium">Status</div>
                                                    <RadioGroup
                                                        className="flex gap-4"
                                                        value={data?.isAvailable == 1 ? "1" : data?.isAvailable == 0 ? "2" : undefined}
                                                        disabled={locationProps?.data?.statusRefId == 4}
                                                        onValueChange={(v: any) => onhandle({ target: { value: Number(v) } }, index, data)}
                                                    >
                                                        <label className="flex items-center gap-1.5 text-sm">
                                                            <RadioGroupItem value="1" /> Available
                                                        </label>
                                                        <label className="flex items-center gap-1.5 text-sm">
                                                            <RadioGroupItem value="2" /> Missed
                                                        </label>
                                                    </RadioGroup>
                                                </div>
                                                :
                                                (statusRefIdOnClick === 2 || locationProps?.data?.statusRefId === 3) && data?.isAvailable != 1 ?
                                                    <div className="mt-3 flex items-center gap-1.5 border-t pt-3 text-sm text-destructive">
                                                        <img src={AppImages?.missingimg} alt="" />
                                                        <div>Missing</div>
                                                    </div>
                                                    :
                                                    <div className="mt-3 flex items-center gap-1.5 border-t pt-3 text-sm text-emerald-600">
                                                        <img src={AppImages?.tickimg} alt="" />
                                                        <div>Available</div>
                                                    </div>

                                            :
                                            locationProps?.data?.statusRefId != 3 && (single == 0 &&
                                                statusRefIdOnClick == null) ?
                                                <div className="mt-3 flex items-center justify-between border-t pt-3">
                                                    <div className="text-sm">
                                                        <div className="text-muted-foreground">Item Count</div>
                                                        <button type="button" className="font-semibold text-primary underline-offset-2 hover:underline" onClick={() => itemDrawerFunc(data)}>{data?.itemCount}</button>
                                                    </div>
                                                    <div className="flex gap-4 text-sm">
                                                        <div className="flex items-center gap-1.5">
                                                            <img src={AppImages?.tickimg} alt="" />
                                                            <div>
                                                                <div>Available</div>
                                                                <div className="font-semibold">{data?.availableCount != null ? data?.availableCount : 0}</div>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-1.5">
                                                            <img src={AppImages?.missingimg} alt="" />
                                                            <div>
                                                                <div>Missing</div>
                                                                <div className="font-semibold">{data?.missingCount != null ? data?.missingCount : 0}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="mt-3 flex gap-4 border-t pt-3 text-sm">
                                                    <div className="flex items-center gap-1.5">
                                                        <img src={AppImages?.tickimg} alt="" />
                                                        <div>Available - {data?.availableCount}</div>
                                                    </div>
                                                    <div className="flex items-center gap-1.5">
                                                        <img src={AppImages?.missingimg} alt="" />
                                                        <div>Missing - {data?.missingCount}</div>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                )
                            }))
                            : <div className="col-span-full"><EmptyState /></div>
                        )
                    }
                </div>
                <LoadingOverlay loading={createOrUpdateProductStatusLoad} />
            </div>
        )
    }

    return (
        <div>
            <div>
                {available()}
                {itemCountDrawer()}
            </div>
        </div>
    )
}

export default StatusCycleCount
